<template>
  <tabs :selected="activeTab" @select="onSelectTab" :tabs="tabs">
    <template v-slot:All>
      <contacts
        v-if="activeTab === 0 && tabs.length === 3"
        :type="0"
      ></contacts>
    </template>
    <template v-slot:Suppliers>
      <contacts
        v-if="
          (tabs.length === 1 && activeTab === 0) ||
          (tabs.length === 3 && activeTab === 1)
        "
        :type="1"
      ></contacts>
    </template>
    <template v-slot:Customers>
      <contacts
        v-if="activeTab === 2 && tabs.length === 3"
        :type="2"
      ></contacts>
    </template>
  </tabs>
</template>

<script>
import { defineComponent } from "vue";
import { TabStrip } from "@progress/kendo-vue-layout";
import ContactsComponent from "../components/contacts/index.vue";

// const initialTabs = [
//   {
//     title: "All",
//     content: "All",
//   },
//   {
//     title: "Suppliers",
//     content: "Suppliers",
//   },
//   {
//     title: "Customers",
//     content: "Customers",
//   },
// ];

export default defineComponent({
  name: "ContactsPage",
  components: {
    tabs: TabStrip,
    contacts: ContactsComponent,
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          title: "All",
          content: "All",
        },
        {
          title: "Suppliers",
          content: "Suppliers",
        },
        {
          title: "Customers",
          content: "Customers",
        },
      ],
      supplierOnly: "",
    };
  },
  computed: {},
  watch: {},
  methods: {
    onSelectTab(event) {
      this.activeTab = event.selected;
    },
    getSettings() {
      const apiUrl = new URL(`${process.env.VUE_APP_BASE_URL}mySettingsForm`);
      apiUrl.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);

      fetch(apiUrl.href, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Accept: "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          // Handle your settings data here
          let customSettings = data.settings && data.settings.customSettings;
          if (typeof customSettings === "string") {
            customSettings = JSON.parse(customSettings);
          }

          // Default: only show Suppliers tab
          let showThreeTabs = false;

          if (
            customSettings &&
            typeof customSettings.SupplierOnly === "string" &&
            customSettings.SupplierOnly.toLowerCase() === "customer"
          ) {
            showThreeTabs = true;
          }

          if (showThreeTabs) {
            this.tabs = [
              { title: "All", content: "All" },
              { title: "Suppliers", content: "Suppliers" },
              { title: "Customers", content: "Customers" },
            ];
            this.supplierOnly = customSettings.SupplierOnly;
          } else {
            this.tabs = [{ title: "Suppliers", content: "Suppliers" }];
            this.supplierOnly = customSettings
              ? customSettings.SupplierOnly
              : "";
          }
        })
        .catch((error) => {
          console.log("Error fetching settings:", error);
        });
    },
  },
  async mounted() {
    // on mount, calling the api
    await this.getSettings();
  },
  created() {
    document.title = "EzzyBills Contacts";
  },
});
</script>

<style scoped></style>
